<template>
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal">
        <div class="my-account-title" v-if="FormInputs.IndividualLabels">Shipping Address</div>
        <div class="my-account-title" v-if="FormInputs.BusinessLabels">My Office Location Information</div>
        <div class="my-account-title" v-if="FormInputs.NonProfitLabels">My Location Information</div>
        <div class="account_section_box">
            <div class="row">
                <div  class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <p v-if="FormInputs.IndividualLabels">Please enter your shipping address information</p>
                    <p v-if="FormInputs.NonProfitLabels || FormInputs.BusinessLabels">Please enter the following information for your primary location</p>
                </div>
            </div>
            <div class="row" v-show="FormInputs.ContactIsMultiLocation">
                <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                    <label class="account_label" v-if="FormInputs.BusinessLabels">Multi-Location Business:</label>
                    <label class="account_label" v-else>Multi-Location Organization:</label>
                </div>
                <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8">
                    <div class="form-group">
                        <div class="radio">
                            <label>
                                <input type="radio" value="true" v-model="AccountEdit.primaryContact.isMultiLocation" name="IsMultilocation"> Yes
                            </label>
                        </div>
                        <div class="radio">
                            <label>
                                <input type="radio" value="false" v-model="AccountEdit.primaryContact.isMultiLocation" name="IsMultilocation"> No
                            </label>
                        </div>
                    </div>
                </div>
            </div>
           <div class="row" v-if="FormInputs.OfficeLocationName && (AccountEdit.primaryContact.isMultiLocation == 'true' || AccountEdit.primaryContact.isMultiLocation == true)">
                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <label class="account_label">Location Name:</label>
                </div>
                <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                    <label v-if="FormInputs.BusinessLabels">Office Location Name*</label>
                    <label v-if="FormInputs.NonProfitLabels">Chapter Location Name*</label>
                    <div class="form-group">
                        <input v-bind:class="{error_field: OfficeLocationValidationResult.OfficeLocationName }" v-model="AccountEdit.primaryContact.officeLocation.name" type="text" class="form-control input_field input_field">
                        <p class="error-message" v-if="OfficeLocationValidationResult.OfficeLocationName">{{ OfficeLocationValidationResult.OfficeLocationName}}</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <label class="account_label">Shipping Address:</label>
                </div>
                <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                    <div class="row">
                        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8">
                            <div class="form-group" v-show="FormInputs.OfficeLocationStreetAddress">
                                <label>Street Address*</label>
                                <input v-bind:class="{error_field: OfficeLocationValidationResult.OfficeLocationStreetAddress }" v-model.lazy="AccountEdit.primaryContact.officeLocation.streetAddress"  @change="addressChanged" type="text" class="form-control input_field input_field">
                                <p class="error-message" v-if="OfficeLocationValidationResult.OfficeLocationStreetAddress">{{ OfficeLocationValidationResult.OfficeLocationStreetAddress}}</p>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                            <div class="form-group" v-show="FormInputs.OfficeLocationSuite">
                                <label>Suite</label>
                                <input v-model="AccountEdit.primaryContact.officeLocation.suite" type="text" class="form-control input_field input_field">
                            </div>
                        </div>
                    </div>
                    <div class="row">       
                        <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                            <div class="form-group" v-show="FormInputs.OfficeLocationCity">
                                <label>City*</label>
                                <input v-bind:class="{ error_field: OfficeLocationValidationResult.OfficeLocationCity }" v-model="AccountEdit.primaryContact.officeLocation.city" type="text" class="form-control input_field input_field">
                                <p class="error-message" v-if="OfficeLocationValidationResult.OfficeLocationCity">{{OfficeLocationValidationResult.OfficeLocationCity}}</p>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                            <div class="form-group" v-show="FormInputs.OfficeLocationState">
                                <label>State*</label>
                                <select v-bind:class="{ error_field: OfficeLocationValidationResult.OfficeLocationState }" v-model="AccountEdit.primaryContact.officeLocation.state" class="form-control input_field select_field" >
                                    <option v-for="(value, key) in State" v-bind:value="value">{{value}}</option>
                                </select>
                                <p class="error-message" v-if="OfficeLocationValidationResult.OfficeLocationState">{{OfficeLocationValidationResult.OfficeLocationState}}</p>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                            <div class="form-group" v-show="FormInputs.OfficeLocationZip">
                                <label>Zip Code*</label> 
                                <span v-if="IsValidNPI">
                                    <i class="fa fa-check-circle check_icon"></i>
                                </span>
                                <span v-if="IsAddressValidating" class="loading_icon">
                                    <img src="../../../../../static/img/loading.gif" style="width: 25px"/>
                                </span>
                                <input v-on:blur="ValidateAddress()" v-on:keypress="G_NumberCheck(this.event)" maxlength="5" v-bind:class="{error_field: OfficeLocationValidationResult.OfficeLocationZip }" v-model="AccountEdit.primaryContact.officeLocation.zip" type="text" class="form-control input_field input_field">
                                <p class="error-message" v-if="OfficeLocationValidationResult.OfficeLocationZip">{{OfficeLocationValidationResult.OfficeLocationZip}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" v-show="FormInputs.OfficeLocationPhoneNumber">
                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <label class="account_label"></label>
                </div>
                <div class="col-lg-8 col-md-9 col-sm-12 col-xs-12">
                    <div class="form-group">
                        <label>Phone Number<span v-if="AccountEdit.primaryContact.isMultiLocation == 'true' || AccountEdit.primaryContact.isMultiLocation == true">*</span></label>
                        <div class="row div-phone">
                            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-4 sm">
                                <input ref="office_number_1" type="text" maxlength="3" v-on:keypress="NumberCheck(this.event)" v-on:keyup="NextField(1)" v-bind:class="{error_field: OfficeLocationValidationResult.OfficeLocationPhoneNumber }" v-model="AccountEdit.primaryContact.officeLocation.countryCode" class="form-control input_field input_field">
                            </div>
                                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-4 sm">
                                <input ref="office_number_2" type="text" maxlength="3" v-on:keypress="NumberCheck(this.event)" v-on:keyup="NextField(2)" v-bind:class="{error_field: OfficeLocationValidationResult.OfficeLocationPhoneNumber }" v-model="AccountEdit.primaryContact.officeLocation.areaCode" class="form-control input_field input_field">
                            </div>
                                <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 md">
                                <input ref="office_number_3" type="text" maxlength="4" v-on:keypress="NumberCheck(this.event)" v-bind:class="{error_field: OfficeLocationValidationResult.OfficeLocationPhoneNumber }" v-model="AccountEdit.primaryContact.officeLocation.phone" class="form-control input_field input_field">
                            </div>
                        </div>
                            <p class="error-message" v-if="OfficeLocationValidationResult.OfficeLocationPhoneNumber">{{OfficeLocationValidationResult.OfficeLocationPhoneNumber}}</p>
                    </div>
                </div>
            </div>
             
            <div class="row" v-show="FormInputs.OfficeLocationEmailAddress && (AccountEdit.primaryContact.isMultiLocation == 'true' || AccountEdit.primaryContact.isMultiLocation == true)">
                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <label class="account_label" v-if="FormInputs.BusinessLabels"></label>
                    <label class="account_label" v-else>Location Contact Email Address:</label>
                </div>
                <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                    <div class="form-group" v-show="FormInputs.OfficeLocationEmailAddress">
                        <label v-if="FormInputs.BusinessLabels">Office Contact Email Address<span v-if="AccountEdit.primaryContact.isMultiLocation == 'true' || AccountEdit.primaryContact.isMultiLocation == true">*</span>
                            <span data-balloon="This is an alternative email address. Your primary contact email address is your login email." data-balloon-pos="down" data-balloon-length="large"><i class="fa fa-question-circle-o"></i></span>
                        </label>
                        <label v-if="FormInputs.NonProfitLabels">Location Contact Email Address<span v-if="AccountEdit.primaryContact.isMultiLocation == 'true' || AccountEdit.primaryContact.isMultiLocation == true">*</span>
                            <span data-balloon="This is an alternative email address. Your primary contact email address is your login email." data-balloon-pos="down" data-balloon-length="large"><i class="fa fa-question-circle-o"></i></span>
                        </label>
                        
                        <input v-model="AccountEdit.primaryContact.officeLocation.emailAddress" v-bind:class="{error_field: OfficeLocationValidationResult.OfficeLocationEmailAddress }" type="email" class="form-control input_field input_field" oninput="this.value = this.value.toLowerCase()">
                        <p class="error-message" v-if="OfficeLocationValidationResult.OfficeLocationEmailAddress">{{OfficeLocationValidationResult.OfficeLocationEmailAddress}}</p>
                    </div>
                </div>
            </div>
            <div class="row" v-show="FormInputs.OfficeLocationContact && (AccountEdit.primaryContact.isMultiLocation == 'true' || AccountEdit.primaryContact.isMultiLocation == true)">
                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <label class="account_label" v-if="FormInputs.BusinessLabels">Office Contact:</label>
                    <label class="account_label" v-else>Location Contact:</label>
                </div>
                <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                    <div class="row">
                        <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                            <div class="form-group" v-show="FormInputs.OfficeLocationContactFirstName">
                                <label v-if="FormInputs.BusinessLabels">First Name<span v-if="AccountEdit.primaryContact.isMultiLocation == 'true' || AccountEdit.primaryContact.isMultiLocation == true">*</span></label>
                                <label v-if="FormInputs.NonProfitLabels">First Name<span v-if="AccountEdit.primaryContact.isMultiLocation == 'true' || AccountEdit.primaryContact.isMultiLocation == true">*</span></label>
                                <input v-model="AccountEdit.primaryContact.officeLocation.contactFirstName" v-bind:class="{error_field: OfficeLocationValidationResult.OfficeLocationContactFirstName }" type="text" class="form-control input_field">
                                <p class="error-message" v-if="OfficeLocationValidationResult.OfficeLocationContactFirstName">{{OfficeLocationValidationResult.OfficeLocationContactFirstName}}</p>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                            <div class="form-group" v-show="FormInputs.OfficeLocationContactLastName">
                                <label v-if="FormInputs.BusinessLabels">Last Name<span v-if="AccountEdit.primaryContact.isMultiLocation == 'true' || AccountEdit.primaryContact.isMultiLocation == true">*</span></label>
                                <label v-if="FormInputs.NonProfitLabels">Last Name<span v-if="AccountEdit.primaryContact.isMultiLocation == 'true' || AccountEdit.primaryContact.isMultiLocation == true">*</span></label>
                                <input v-model="AccountEdit.primaryContact.officeLocation.contactLastName" v-bind:class="{error_field: OfficeLocationValidationResult.OfficeLocationContactLastName }" type="text" class="form-control input_field">
                                <p class="error-message" v-if="OfficeLocationValidationResult.OfficeLocationContactFirstName">{{OfficeLocationValidationResult.OfficeLocationContactLastName}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" v-show="FormInputs.OfficeLocationContactRole && (AccountEdit.primaryContact.isMultiLocation == 'true' || AccountEdit.primaryContact.isMultiLocation == true)">
                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <label class="account_label" v-if="FormInputs.BusinessLabels"></label>
                    <label class="account_label" v-else>Role in Organization:</label>
                </div>
                <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                    <div class="form-group">
                        <label v-if="FormInputs.BusinessLabels">Role in Business</label>
                        <label v-if="FormInputs.NonProfitLabels">Role in Organization</label>
                        <select v-model="AccountEdit.primaryContact.officeLocation.contactRole" class="form-control select_field" style="height: 36.5px;">
                            <option v-for="(value, key) in  (FormInputs.RoleBusiness ? RoleBusiness : RoleNonProfit)" v-bind:value="value">{{key}}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['AccountEdit', 'OfficeLocationValidationResult', 'FormInputs', 'State', 'RoleNonProfit',
                'RoleBusiness', 'IsValidNPI', 'IsAddressValidating'],
        data(){
            return{
                isInviteDoctor:false,
                total:0
            }
        },
        computed:{
            pledge: function(){
                var text = null;
                if(this.$route.params.type == "Individual"){
                    text = "The participant pledges to do the following number of charitable jobs this calendar year.*";
                }
                else if(this.$route.params.type == "Business"){
                    text = "This location of the business pledges/forecasts to serve the do the following number of charitable jobs this calendar year.*";
                }
                else if(this.$route.params.type == "NonProfit"){
                    text = "This location of the organization forecasts to do the following number of charitable jobs this calendar year.*";
                }
                return text;
            }
        },
        methods:{
            addressChanged(evt){
                // this.AccountEdit.primaryContact.officeLocation.streetAddress = this.RemovePOBOX(this.AccountEdit.primaryContact.officeLocation.streetAddress.toString())
                if(this.AccountEdit.primaryContact.officeLocation.streetAddress){
                    let check_PO_BOX  = this.checkIfAddressHasPO_BOX(this.AccountEdit.primaryContact.officeLocation.streetAddress.toString()) 
                    if(check_PO_BOX == true){
                    alert("Sorry, our labs cannot ship to a PO BOX. Please enter a valid shipping address.")
                        return
                    }
                }
            },
            NumberCheck(evt){
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();;
                } 
                // else {
                //     this.FocusNextField(this.$refs.participant_number_1, this.$refs.participant_number_2, this.$refs.participant_number_3);
                //     return true;
                // }
            },
            NextField(field){
                var focus1 = this.$refs.office_number_1;
                var focus2 = this.$refs.office_number_2;
                var focus3 = this.$refs.office_number_3;

                if(field == 1 && focus1.value.length == 3){
                    focus2.focus();
                    }
                else if (field == 2 && focus2.value.length == 3){
                    focus3.focus();
                    }
            },
            FocusNextField(element1,element2,element3){
                if(element1.value.length == 2){
                    element2.focus();   
                }
                else if (element2.value.length == 2){
                    element3.focus();
                }
            },
            ValidateAddress() {
                this.$emit("addressCheck");
            }
        }
    }
</script>



// WEBPACK FOOTER //
// EditLocationInfo.vue?4d4ba236